<template>
  <span>
    {{ dataFormatada }}
  </span>
</template>


<script setup>
import { computed } from 'vue'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

// Ativando os plugins
dayjs.extend(utc)
dayjs.extend(timezone)

// Recebendo dataISO via props
const props = defineProps({
  dataISO: {
    type: String,
    required: false
  }
})

// Detecta o fuso horário do navegador ou usa "America/Sao_Paulo" como padrão
const userTimeZone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone || 'America/Sao_Paulo'

// Convertendo para o fuso horário do usuário ou padrão
const dataFormatada = computed(() =>
  dayjs.utc(props.dataISO).tz(userTimeZone).format('DD/MM/YYYY HH:mm:ss')
)
</script>
